/**
 * Browser / platform detection helpers.
 * Extracted into a separate module so components stay testable —
 * tests mock this module to simulate iOS / Android / desktop environments.
 */

export const isIOS =
  /iPad|iPhone|iPod/.test(navigator.userAgent) ||
  (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);

export const isAndroid = /Android/.test(navigator.userAgent);

export const isMobileBrowser = isIOS || isAndroid;

// false on iOS/Android (WebKit blocks inline PDF in iframes; Android Chrome
// silently fails blob-URL iframes)
export const canInlinePdf =
  !isMobileBrowser && navigator.pdfViewerEnabled !== false;
